import { AgreementsDocumentVersionModel } from '.'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'

export default class AgreementsDocument extends BaseModel {
  id: string = ''
  title: string = ''
  code: string = ''
  isRequired: boolean = false
  versions: Array<AgreementsDocumentVersionModel> = []
  actualVersion: AgreementsDocumentVersionModel | null = null

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['versions', 'actualVersion'])

      if (Array.isArray(data.versions)) {
        this.versions = data.versions.map(i => new AgreementsDocumentVersionModel(i))
      }

      this.actualVersion = isUnknownObject(data.actual_version)
        ? new AgreementsDocumentVersionModel(data.actual_version)
        : this.versions.find(i => i.isActual) ?? null
    }
  }
}
